/**
 * @generated SignedSource<<9c68e70f8de42d881774d549c9b48451>>
 * @relayHash 9a452feee888342f02ab962c634b8b1e
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9a452feee888342f02ab962c634b8b1e

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectV2ItemType = "DRAFT_ISSUE" | "ISSUE" | "PULL_REQUEST" | "REDACTED" | "%future added value";
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type ClearProjectV2ItemFieldValueInput = {
  clientMutationId?: string | null;
  fieldId: string;
  itemId: string;
  projectId: string;
};
export type clearProjectItemFieldValueMutation$variables = {
  input: ClearProjectV2ItemFieldValueInput;
};
export type clearProjectItemFieldValueMutation$data = {
  readonly clearProjectV2ItemFieldValue: {
    readonly projectV2Item: {
      readonly fieldValueByName: {
        readonly name?: string | null;
      } | null;
      readonly fieldValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"DateFieldFragment" | "IterationFieldFragment" | "NumberFieldFragment" | "SingleSelectFieldFragment" | "TextFieldFragment">;
          } | null;
        } | null> | null;
      };
      readonly id: string;
      readonly project: {
        readonly id: string;
      };
      readonly type: ProjectV2ItemType;
    } | null;
  } | null;
};
export type clearProjectItemFieldValueMutation$rawResponse = {
  readonly clearProjectV2ItemFieldValue: {
    readonly projectV2Item: {
      readonly fieldValueByName: {
        readonly __typename: "ProjectV2ItemFieldSingleSelectValue";
        readonly __isNode: "ProjectV2ItemFieldSingleSelectValue";
        readonly id: string;
        readonly name: string | null;
      } | {
        readonly __typename: string;
        readonly __isNode: string;
        readonly id: string;
      } | null;
      readonly fieldValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: "ProjectV2ItemFieldDateValue";
            readonly __isNode: "ProjectV2ItemFieldDateValue";
            readonly date: any | null;
            readonly field: {
              readonly __typename: "ProjectV2Field";
              readonly __isNode: "ProjectV2Field";
              readonly id: string;
              readonly name: string;
            } | {
              readonly __typename: string;
              readonly __isNode: string;
              readonly id: string;
            };
            readonly id: string;
          } | {
            readonly __typename: "ProjectV2ItemFieldIterationValue";
            readonly __isNode: "ProjectV2ItemFieldIterationValue";
            readonly duration: number;
            readonly field: {
              readonly __typename: "ProjectV2IterationField";
              readonly __isNode: "ProjectV2IterationField";
              readonly configuration: {
                readonly completedIterations: ReadonlyArray<{
                  readonly duration: number;
                  readonly id: string;
                  readonly startDate: any;
                  readonly title: string;
                  readonly titleHTML: string;
                }>;
                readonly iterations: ReadonlyArray<{
                  readonly duration: number;
                  readonly id: string;
                  readonly startDate: any;
                  readonly title: string;
                  readonly titleHTML: string;
                }>;
              };
              readonly id: string;
              readonly name: string;
            } | {
              readonly __typename: string;
              readonly __isNode: string;
              readonly id: string;
            };
            readonly id: string;
            readonly iterationId: string;
            readonly startDate: any;
            readonly title: string;
            readonly titleHTML: string;
          } | {
            readonly __typename: "ProjectV2ItemFieldNumberValue";
            readonly __isNode: "ProjectV2ItemFieldNumberValue";
            readonly field: {
              readonly __typename: "ProjectV2Field";
              readonly __isNode: "ProjectV2Field";
              readonly id: string;
              readonly name: string;
            } | {
              readonly __typename: string;
              readonly __isNode: string;
              readonly id: string;
            };
            readonly id: string;
            readonly number: number | null;
          } | {
            readonly __typename: "ProjectV2ItemFieldSingleSelectValue";
            readonly __isNode: "ProjectV2ItemFieldSingleSelectValue";
            readonly color: ProjectV2SingleSelectFieldOptionColor;
            readonly field: {
              readonly __typename: "ProjectV2SingleSelectField";
              readonly __isNode: "ProjectV2SingleSelectField";
              readonly id: string;
              readonly name: string;
              readonly options: ReadonlyArray<{
                readonly color: ProjectV2SingleSelectFieldOptionColor;
                readonly name: string;
                readonly nameHTML: string;
                readonly optionId: string;
              }>;
            } | {
              readonly __typename: string;
              readonly __isNode: string;
              readonly id: string;
            };
            readonly id: string;
            readonly name: string | null;
            readonly nameHTML: string | null;
            readonly optionId: string | null;
          } | {
            readonly __typename: "ProjectV2ItemFieldTextValue";
            readonly __isNode: "ProjectV2ItemFieldTextValue";
            readonly field: {
              readonly __typename: "ProjectV2Field";
              readonly __isNode: "ProjectV2Field";
              readonly id: string;
              readonly name: string;
            } | {
              readonly __typename: string;
              readonly __isNode: string;
              readonly id: string;
            };
            readonly id: string;
            readonly text: string | null;
          } | {
            readonly __typename: string;
            readonly __isNode: string;
            readonly id: string;
          } | null;
        } | null> | null;
      };
      readonly id: string;
      readonly project: {
        readonly id: string;
      };
      readonly type: ProjectV2ItemType;
    } | null;
  } | null;
};
export type clearProjectItemFieldValueMutation = {
  rawResponse: clearProjectItemFieldValueMutation$rawResponse;
  response: clearProjectItemFieldValueMutation$data;
  variables: clearProjectItemFieldValueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = [
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "POSITION"
    }
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/)
  ],
  "type": "ProjectV2ItemFieldSingleSelectValue",
  "abstractKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "field",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        (v8/*: any*/)
      ],
      "type": "ProjectV2Field",
      "abstractKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v20 = [
  (v2/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clearProjectItemFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClearProjectV2ItemFieldValuePayload",
        "kind": "LinkedField",
        "name": "clearProjectV2ItemFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectV2Item",
            "kind": "LinkedField",
            "name": "projectV2Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "ProjectV2ItemFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2ItemFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "TextFieldFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "NumberFieldFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "DateFieldFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SingleSelectFieldFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "IterationFieldFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "fieldValues(first:50,orderBy:{\"direction\":\"ASC\",\"field\":\"POSITION\"})"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "fieldValueByName",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": "fieldValueByName(name:\"Status\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "clearProjectItemFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClearProjectV2ItemFieldValuePayload",
        "kind": "LinkedField",
        "name": "clearProjectV2ItemFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectV2Item",
            "kind": "LinkedField",
            "name": "projectV2Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "ProjectV2ItemFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2ItemFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ],
                            "type": "ProjectV2ItemFieldTextValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "number",
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ],
                            "type": "ProjectV2ItemFieldNumberValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "date",
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ],
                            "type": "ProjectV2ItemFieldDateValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v8/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v2/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectV2SingleSelectFieldOption",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": true,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v8/*: any*/),
                                          (v14/*: any*/),
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ProjectV2SingleSelectField",
                                    "abstractKey": null
                                  },
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v15/*: any*/)
                            ],
                            "type": "ProjectV2ItemFieldSingleSelectValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "iterationId",
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v2/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectV2IterationFieldConfiguration",
                                        "kind": "LinkedField",
                                        "name": "configuration",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProjectV2IterationFieldIteration",
                                            "kind": "LinkedField",
                                            "name": "iterations",
                                            "plural": true,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProjectV2IterationFieldIteration",
                                            "kind": "LinkedField",
                                            "name": "completedIterations",
                                            "plural": true,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ProjectV2IterationField",
                                    "abstractKey": null
                                  },
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ProjectV2ItemFieldIterationValue",
                            "abstractKey": null
                          },
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "fieldValues(first:50,orderBy:{\"direction\":\"ASC\",\"field\":\"POSITION\"})"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "fieldValueByName",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v9/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": "fieldValueByName(name:\"Status\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "9a452feee888342f02ab962c634b8b1e",
    "metadata": {},
    "name": "clearProjectItemFieldValueMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "da9c7c7fd81d1e90d9981bf3329cd63d";

export default node;
